import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

export default function Preloader() {
  const [done, setDone] = useState(() => sessionStorage.getItem("ap-intro") === "1");

  useEffect(() => {
    if (done) return;
    const timer = setTimeout(() => {
      sessionStorage.setItem("ap-intro", "1");
      setDone(true);
    }, 2100);
    return () => clearTimeout(timer);
  }, [done]);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          data-testid="preloader"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-0 z-[200] flex items-center justify-center bg-navy noise-bg"
        >
          <div className="text-center">
            <motion.div
              initial={{ opacity: 0, scale: 0.85 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
              className="mx-auto flex h-20 w-20 items-center justify-center rounded-full border border-gold/70 font-display text-2xl text-gold"
            >
              AP
            </motion.div>
            <motion.p
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.8 }}
              className="mt-6 font-display text-3xl font-light text-white"
            >
              Antalia <span className="italic text-gold-light">Pharma</span>
            </motion.p>
            <motion.div
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ delay: 0.4, duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
              className="mx-auto mt-6 h-px w-40 bg-gold/60"
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
